<template>
	<div class="calculatorBox">
		<div class="tip">
			<div>工程计费计算器</div>
			<div>免费使用 ｜ 全国各省市 ｜ 20+费用 ｜ 在线快速计算 ｜ 计算依据 ｜ 提质增效 ｜ 移动办公</div>
		</div>
		<div class="title">
			<img style="margin-top: 8px;" src="~/assets/images/calculter/location.png">
			省份：
			<el-select
				v-model="provience"
				placeholder="请选择所在省份"
				@change="handleAllProvienceChange"
				>
				<el-option
					v-for="item in options"
					:key="item"
					:label="item"
					:value="item"
				></el-option>
			</el-select>
			<span> <i class="el-icon-warning"></i> 若无该地方计算标准将自动切换为全国或其他省市计算标准</span>
		</div>
		<div class="title">
			<img src="~/assets/images/calculter/calculator.png">
			添加计算费用（支持多选，最多6项）
		</div>
		<div
			class="calculator"
			>
			<div class="calculatorTypeList">
				<el-button
					v-for="(item, index) in calculatorTypeList"
					:key="index"
					:type="activeType.includes(item.baseName) ? 'primary' : ''"
					@click="handleChangeType(item.baseName)"
					>
					{{ item.baseName }}
				</el-button>
				<el-button
					type="text"
					@click="jumpToYzkj"
					>
					前往云咨空间使用更多计算器>>
				</el-button>
			</div>

			<div
				v-for="(item, index) in activeType"
				:key="item">
				<CommonItem
					:provience="provience"
					:name="item"
					:ref="item"
					:id="item"
					:index="(index + 1 + '')"
					@calculateData="calculateData"
					@updateBasicCriterion="updateBasicCriterion"
					>
				</CommonItem>
			</div>

			<Summation :resultList="resultList"/>
		</div>
	</div>
</template>

<script>
import Summation from "./components/calculator/layout/Summation.vue";
import CommonItem from "./components/calculator/CommonItem.vue";

export default {
	components: {
		Summation,
		CommonItem,
	},
	data() {
		return {
			activeType: [],
			calculatorTypeList: [],
			options: [],
			provience: '',
			resultList: [],
			showPage: false
		};
	},
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "计费计算器",
    });
  },
	mounted() {
		this.activeType = ['招标代理费']
		this.getProvience()
		this.getBtnList()
	},
	methods: {
		getProvience() {
			this.$get('/web/yzkjhz/hz/cityList?isJsq=2', res => {
                this.options = res
			})
		},

		// 获取form表单展示列表
        getBtnList(param) {
            this.$get('/web/bbs/common/dictbytype.json?type=yzkj_jsq', res => {
				this.calculatorTypeList = res.map(item => {
					item.baseName = item.dicname
					return item
				})
				this.showPage = true
			})
        },

		handleChangeType(type) {
			if(this.activeType.includes(type)){
				// 从数据组中去除
				this.activeType.splice(this.activeType.indexOf(type), 1)
				this.resultList.forEach((item, index) => {
					if(item.engineeringName == type) {
						this.resultList.splice(index, 1)
					}
				});
			}else{
				if(this.activeType.length >= 6) {
					this.$message.error('最多选择6项')
					return
				}else{
					this.activeType.push(type)
				}
			}
		},

		handleAllProvienceChange(value) {
			this.activeType.forEach((item) => {
				this.$refs[item][0].$refs.container.handleAllProvienceChange(value)
			})
		},

		updateBasicCriterion(name, data) {
			this.resultList.forEach((item, index) => {
				if(item.engineeringName == name) {
					item.basicCriterionFileUrl = data.describeValue
					item.basicCriterion = data.priceDescribe
				}
			});
		},

		calculateData(data, id, customResult) {
			this.$post(
				"/web/yzkjhz/hz/calculator",
				data,
				res => {
					res[0].basicCriterionFileUrl = ''
					res[0].priceDetailList.forEach(item => {
						if(item.describeName == '计算依据'){
							res[0].basicCriterionFileUrl = item.describeValue
						}
					})
					let isExist = false;
					let arrIndex = null;
					this.resultList.forEach((item, index) => {
						if(item.engineeringName == res[0].engineeringName) {
							isExist = true
							arrIndex = index
						}
					});
					res[0].discountRatio = this.$refs[id][0].getDiscountRatio()
					this.$notify({
						title: '计算成功',
						type: 'success'
					});
					// 是否有特殊结果
					let fixedResult = this.$refs[id][0].getFixedResult()
					if(fixedResult != '/') {
						res[0].beforeSummation = fixedResult
						res[0].summation = fixedResult
					}
					if(customResult) res = customResult
					this.$refs[id][0].refreshResult(res);
					if(!isExist){
						this.resultList.push(res[0])
					}else{
						this.$set(this.resultList, arrIndex, res[0])
					}
				},
				true
			)
		},

		jumpToYzkj() {
			window.open("https://www.yunzikongjian.com/tool/calculator")
		}
	},
};
</script>

<style scoped lang="scss">
.calculator {
	padding: 0 70px;
	min-height: calc(100vh - 170px);

	.calculatorTypeList {
		padding:0 0 10px;

		button {
			margin-bottom: 10px;
			margin-right: 10px;
			margin-left: 0 !important;
		}
	}
}
.calculatorBox {
	padding-top: 70px;
	.tip {
		height: 120px;
		font-size: 16px;
		background-image: url('@/assets/images/calculter/calculatorBg.png');
		margin: 25px 70px;
		background-size: cover;
		padding: 28px 52px;
		font-weight: 600;
		position: relative;
		div {
			color: #2F74FF;
			font-size: 18px;
		}
		div:first-child {
			font-size: 24px;
			padding-bottom: 20px;
		}
		img {
			position: absolute;
			right: 5px;
			top: 30px;
			width: 185px;
			height: 185px;
		}
	}

	.title {
		color: #333333;
		font-size: 16px;
		padding: 0 70px 20px;
		font-weight: 600;

		img {
			float: left;
			margin-right: 10px;
		}

		span {
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			margin-left: 20px;
		}
	}

	.calculator {
		padding: 0 70px;
		min-height: calc(100vh - 170px);

		.calculatorTypeList {
			padding:0 0 10px;

			button {
				margin-bottom: 10px;
				margin-right: 10px;
				margin-left: 0 !important;
			}
		}
	}
}
/deep/.hoverTip {
	margin-top: -10px;
	padding-left: 100px;
	margin-bottom: 10px;
	color: red;
}
</style>
